import { render, staticRenderFns } from "./SVGIcon.vue?vue&type=template&id=284217c9&scoped=true"
import script from "./SVGIcon.vue?vue&type=script&lang=js"
export * from "./SVGIcon.vue?vue&type=script&lang=js"
import style0 from "./SVGIcon.vue?vue&type=style&index=0&id=284217c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284217c9",
  null
  
)

export default component.exports